import { render, staticRenderFns } from "./SkillsOverview.vue?vue&type=template&id=642fb6af&scoped=true"
import script from "./SkillsOverview.vue?vue&type=script&lang=js"
export * from "./SkillsOverview.vue?vue&type=script&lang=js"
import style0 from "./SkillsOverview.vue?vue&type=style&index=0&id=642fb6af&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642fb6af",
  null
  
)

export default component.exports